import React, { useState } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import MDBox from "components/MDBox";

function EntityVisual({ entityObject }) {
    const [imgSrc, setImgSrc] = useState(
        entityObject?.full_picture ||
        entityObject?.thumbnailUrl ||
        entityObject?.thumbnail_url ||
        entityObject?.profileObject?.profilePictureUrl ||
        "/images/placeholder.png"
    );

    return (
        <MDBox
            width={{ xs: "100%", md: "41.666667%" }}
            sx={{
                position: "relative",
                backgroundColor: "#000000",
                borderRadius: 2,
                boxShadow: 2,
                overflow: "hidden",
                minHeight: { xs: "300px", md: "0px" },
            }}
        >
            <MDBox
                sx={{
                    position: { xs: "absolute", md: "absolute" },
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                }}
            >
                <Box
                    component="img"
                    src={imgSrc}
                    alt="Post Thumbnail"
                    onError={() =>
                        setImgSrc(
                            entityObject?.profile?.profilePictureUrl ||
                            "/images/placeholder.png"
                        )
                    }
                    sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        display: "block",
                    }}
                />
            </MDBox>
        </MDBox>
    );
}

EntityVisual.propTypes = {
    entityObject: PropTypes.object.isRequired,
};

export default EntityVisual;
